<template>
    <nav class="overflow-auto pb-0 lg:pb-1 sm:container" :aria-label="$t('a11y.event_categories_navigation')">
        <ul class="tabs flex justify-between lg:border-b lg:border-gray-600 px-1 pt-1">
            <li v-for="category in $store.state.data.eventCategories" :key="`event-category-tab-${category.id}`">
                <button
                    class="tab-link"
                    :class="{ 'tab-link--active': $route.query.category === category.slug }"
                    :aria-current="$route.query.category === category.slug"
                    @click="() => handleTabClick(category.slug)"
                >
                    <EventCategoryBadge :type="category.id" transparent icon-only />
                    <span class="whitespace-nowrap hidden sm:inline-block">
                        <T :t="`navigation.category_${category.id}_programs`" />
                    </span>
                    <span class="whitespace-nowrap sm:hidden">
                        <T :t="`navigation.category_${category.id}_programs_short`" />
                    </span>
                </button>
            </li>
        </ul>

        <a
            tabindex="0"
            href=""
            class="opacity-0 absolute bottom-0 rounded-lg left-1/2 -translate-x-1/2 transition-all bg-white text-black p-4 focus:opacity-100 focus-visible:translate-y-full focus-visible:-bottom-4 dark:focus-visible:outline-white"
            @click.prevent="handleSkipLinkClick"
        >
            {{ $t('a11y.skip_to_search_results') }}
        </a>
    </nav>
</template>

<script>
import EventCategoryBadge from '~/components/UI/EventCategoryBadge.vue';
export default {
    name: 'EventCategoryTabBar',
    components: {
        EventCategoryBadge,
    },
    methods: {
        handleSkipLinkClick() {
            const focusMagnet = document.getElementsByClassName('event-list-focus-magnet')[0];

            if (focusMagnet) {
                focusMagnet.focus();
            }
        },
        handleTabClick(category) {
            if (this.$route.query.category === category) {
                return;
            }

            const _updatedQuery = { ...this.$route.query };
            _updatedQuery.category = category;

            this.$router.push(
                this.localePath({
                    name: 'programs-in-varosliget',
                    query: _updatedQuery,
                })
            );
        },
    },
};
</script>

<style scoped>
.tab-link {
    @apply relative px-4 py-2 flex flex-col items-center;
}

.tab-link::after {
    content: '';
    @apply block absolute bottom-0 lg:bottom-[-3px] left-0 w-full h-[5px] bg-black z-1 rounded-full opacity-0 transition-opacity;
}

.tab-link.tab-link--active {
    @apply font-bold;
}

.tab-link.tab-link--active::after {
    @apply opacity-100;
}

@media (hover: hover) {
    .tab-link:hover::after {
        @apply opacity-100;
    }
}
</style>
